import { ICluster, IContact } from '@nkr/models/index';
import JoditEditor from '@nkr/components/editor';
import config from '@nkr/views/ticketing/jodit-editor-config';
import Swaps from '../common/swaps';
import SwapManager from '../common/swap-manager';

interface IProps {
    message: string,
    swaps: ICluster[],
    swapManager: IContact,
    swapNumber: string,
    dateTime: string,
    onMessageChange: (message: string) => void
}

const KickoffCall = (props: IProps) => {
    const handleMessageChange = (message: string) => {
        props.onMessageChange(message);
    };

    const joditConfig = { ...config, height: '300px' };

    return (
        <>
            <div style={{ marginBottom: 20 }}>
                Kickoff Call for Swap {props.swapNumber} scheduled for {props.dateTime} ET
            </div>

            <div style={{ marginBottom: 20 }}>
                <table>
                    <tbody>
                        <tr>
                            <td>Dial-in:</td>
                            <td style={{ paddingLeft: 10 }}>{props.swapManager.conferenceNumber}</td>
                        </tr>
                        <tr>
                            <td>Mobile Friendly Dial-in:</td>
                            <td style={{ paddingLeft: 10 }}>{props.swapManager.conferenceNumberMobileFriendly}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <JoditEditor
                value={props.message}
                config={joditConfig}
                onChange={handleMessageChange}
                onBlur={() => null}
            />
            <br />

            <div style={{ marginBottom: 5 }}><strong>Swap Configuration</strong></div>

            <Swaps includePreselectStatus={true} swaps={props.swaps} />

            <div style={{ marginBottom: 5 }}><strong>Swap Manager</strong></div>

            <SwapManager data={props.swapManager} />
        </>
    );
}

export default KickoffCall;